import { Button } from '../../common/Button';

interface RoomNotFoundProps {
  onBack: () => void;
  error: string | null;
}

/**
 * Error state when room is not found.
 */
export function RoomNotFound({ onBack, error }: RoomNotFoundProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-primary">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 rounded-full bg-danger/10 flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-danger" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h1 className="text-xl font-semibold mb-2">Room Not Found</h1>
        <p className="text-gray-400 mb-6">
          {error || "The room you're looking for doesn't exist or you don't have access."}
        </p>
        <Button onClick={onBack}>Back to Home</Button>
      </div>
    </div>
  );
}
